// Configuration for different environments
const config = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    socketUrl: process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000',
    env: 'development',
    giphyApiKey: process.env.REACT_APP_GIPHY_API_KEY || 'PiraJwEePArXyEXtRltTaXxfec32hFio',
    // ATOZAS SSO client. `enabled` shows the "Continue with ATOZAS" control and
    // lets the app bootstrap from the backend HttpOnly session. `autoRedirect`
    // sends unauthenticated visitors straight to /auth/atozas. Issuer is on
    // the backend: staging testatozas.in/atozaswebsite, live www.atozasindia.in.
    atozasSso: {
      enabled: process.env.REACT_APP_ATOZAS_SSO_ENABLED === 'true',
      autoRedirect: process.env.REACT_APP_ATOZAS_SSO_AUTO_REDIRECT === 'true',
    },
    // Keep ICE server count small; 5+ entries can slow candidate discovery.
    // Prefer 1 STUN + a couple of TURN transports.
    iceServers: (() => {
      const list = [
        // Primary STUN
        { urls: 'stun:stun.l.google.com:19302' },
        // TURN relay fallback
        {
          urls: 'turn:openrelay.metered.ca:80',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        },
        {
          urls: 'turn:openrelay.metered.ca:443',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        },
        {
          urls: 'turn:openrelay.metered.ca:443?transport=tcp',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        }
      ];
      // Allow custom TURN from environment (appended)
      const turnUrl = process.env.REACT_APP_TURN_URL;
      const turnUser = process.env.REACT_APP_TURN_USERNAME;
      const turnPass = process.env.REACT_APP_TURN_PASSWORD;
      if (turnUrl && turnUser && turnPass) {
        list.push({ urls: turnUrl.split(','), username: turnUser, credential: turnPass });
      }
      return list;
    })(),
    // Force using TURN-only (relay) for debugging one-way audio issues
    forceRelay: process.env.REACT_APP_FORCE_TURN === 'true'
  },
  production: {
    // IMPORTANT:
    // Default to current site origin so the same production build works correctly on
    // `ucmaapp.testatozas.in` (staging) as well as `www.ucmaapp.com` (primary).
    // You can still override via REACT_APP_API_URL / REACT_APP_SOCKET_URL.
    apiUrl:
      process.env.REACT_APP_API_URL ||
      (typeof window !== 'undefined' ? window.location.origin : 'https://www.ucmaapp.com'),
    socketUrl:
      process.env.REACT_APP_SOCKET_URL ||
      (typeof window !== 'undefined' ? window.location.origin : 'https://www.ucmaapp.com'),
    env: 'production',
    giphyApiKey: process.env.REACT_APP_GIPHY_API_KEY || 'PiraJwEePArXyEXtRltTaXxfec32hFio',
    // ATOZAS SSO client (see development config above for details).
    atozasSso: {
      enabled: process.env.REACT_APP_ATOZAS_SSO_ENABLED === 'true',
      autoRedirect: process.env.REACT_APP_ATOZAS_SSO_AUTO_REDIRECT === 'true',
    },
    // Keep ICE server count small; 5+ entries can slow candidate discovery.
    // Prefer 1 STUN + a couple of TURN transports.
    iceServers: (() => {
      const list = [
        // Primary STUN
        { urls: 'stun:stun.l.google.com:19302' },
        // TURN relay fallback
        {
          urls: 'turn:openrelay.metered.ca:80',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        },
        {
          urls: 'turn:openrelay.metered.ca:443',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        },
        {
          urls: 'turn:openrelay.metered.ca:443?transport=tcp',
          username: 'openrelayproject',
          credential: 'openrelayproject'
        }
      ];
      // Allow custom TURN from environment (appended)
      const turnUrl = process.env.REACT_APP_TURN_URL;
      const turnUser = process.env.REACT_APP_TURN_USERNAME;
      const turnPass = process.env.REACT_APP_TURN_PASSWORD;
      if (turnUrl && turnUser && turnPass) {
        list.push({ urls: turnUrl.split(','), username: turnUser, credential: turnPass });
      }
      return list;
    })(),
    // Set true in production env to force relay via TURN for users behind symmetric NAT
    forceRelay: process.env.REACT_APP_FORCE_TURN === 'true'
  }
};

// Get current environment
const getCurrentEnv = () => {
  // Check if we're in development mode (npm start)
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  // Check if we're in production mode (npm run build)
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  // Default to development
  return 'development';
};

const currentEnv = getCurrentEnv();
const currentConfig = config[currentEnv];

//console.log(`Running in ${currentEnv} mode`);
//console.log(`API URL: ${currentConfig.apiUrl}`);
//console.log(`Socket URL: ${currentConfig.socketUrl}`);

export default currentConfig; 